<!--Full Text Search Code Starts here-->
<div *ngIf="!enableGenAI" class="container-fluid">
    <div class="row">
        <div class="col pt-1 pb-2 shadow-sm ml-2 mr-2 text-center">
            <span style="font-size: 14pt;"><strong>Search Repository</strong></span>
            <div class="row">
                <div class="d-flex col-6 mx-auto">
                    <form class="form-inline w-100" (ngSubmit)="executeSearch()">
                        <input type="text" class="form-control form-control-md mr-2" placeholder="Enter text to search"
                            [(ngModel)]="searchText" [ngModelOptions]="{standalone: true}" style="width: 80%">
                        <button type="submit" class="btn btn-outline-secondary btn-md">Search</button>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <!-- End Search Form-->

    <mat-drawer-container [hasBackdrop]="false" autosize style="height: calc(100vh - 50px); width: 100%">
        <mat-drawer-content>
            <div class="container-fluid">
                <div class="filtercontainer" *ngIf="searchExecuted && searchResults.length > 0">
                    <mat-paginator [pageSizeOptions]="[50, 100]" [pageSize]="50" (page)="selectPage($event)" class="custom-paginator" showFirstLastButtons>
                    </mat-paginator>
                </div>

                <div class="row">
                    <div class="col mt-1" *ngIf="!hideDocList" style="min-width: 800px">
                        <div *ngIf=searchExecuted>
                            <div *ngIf="searchResults.length < 1 && !isEmpty && !backSlash">
                                <div class="alert alert-light text-center">
                                    Sorry, we couldn't find any results matching "{{submittedSearchText}}"
                                </div>
                            </div>
                            <div class="filtercontainer" *ngIf="searchResults.length > 0" style="margin-bottom: 1em;">
                                <!-- Export option - Uncomment for MCR -->
                                <span *ngIf="selection.selected.length > 0">
                                    <button class="uploadbutton" style="margin-bottom: 2px;" mat-raised-button
                                        (click)="exportDocuments()">
                                        <mat-icon>cloud_download</mat-icon> Export Documents
                                    </button>
                                </span>
                                <div *ngIf="totalDoc > 200" style="float:right; margin-top: 1em;">
                                    (Total Count: {{totalDoc | number}})
                                </div>
                                <div class="m-2" *ngIf="totalDoc <= 200" style="float:right; margin-top: 1em;">
                                    (Total Count: {{searchResultCount}})
                                </div>
                            </div>

                            <div class="row" style="margin-bottom: 1em; margin-left: 1em; text-align: left;">
                                <span *ngIf="selection.selected.length>0">
                                    <div>
                                        <a href="javascript:void(0)" (click)="isExportMetaDataCsv=true">Show Export Metadata CSV</a>
                                    </div>
                                    <div>
                                        <span *ngIf="isExportMetaDataCsv">
                                            <label >Enter the expiration time (in Mins - Max upto 480 mins): </label><input type="number" [(ngModel)]="exportExpiration" />&nbsp;
                                            <button [disabled]="exportExpiration == null || exportExpiration <= 0 || exportExpiration > 480" class="uploadbutton" style="margin-bottom: 2px;" mat-raised-button (click)="exportDocumentLink()">
                                                <mat-icon>cloud_download</mat-icon> Export Metadata CSV
                                            </button>
                                            <div *ngIf="exportExpiration <= 0 || exportExpiration > 480" style="color: red; padding-top: 0.2rem">
                                                Please enter the valid expiration time. Expiration time should not exceed 480 mins
                                            </div>
                                        </span>
                                    </div>
                                </span>
                            </div>
                            <mat-form-field *ngIf="searchResults.length > 0" style="margin-left: 1em;">
                                <mat-label>Filter</mat-label>
                                <input matInput (keyup)="applyFilter($event)">
                            </mat-form-field>
                            <div *ngIf="searchResults.length > 0">
                                <div class="row" style="margin-bottom: 1em;">
                                    <div class="col-2">
                                        <button mat-button [matMenuTriggerFor]="menu">
                                            Show/Hide Columns
                                            <mat-menu #menu="matMenu">
                                            <span class="table-config-menu-label">Edit Columns</span>
                                            <div class="table-config-menu-options">
                                                <mat-checkbox 
                                                *ngFor="let cd of selectedFormDisplayList; let i = index"
                                                (click)="$event.stopPropagation()"
                                                [(ngModel)]="cd.visible">
                                                {{cd.name}}
                                                </mat-checkbox>
                                                <button (click)="applyShowHideColumns()">Apply</button>
                                            </div>
                                        </mat-menu>
                                        </button>
                                    </div>           
                                </div>
                                <table mat-table [dataSource]="searchResultsList" matSort aria-describedby="doc-table">

                                    <ng-container matColumnDef="select">
                                        <th mat-header-cell *matHeaderCellDef>
                                            <mat-checkbox #ref (change)="$event ? masterToggle(ref) : null"
                                                [checked]="selection.hasValue() && isAllSelected()"
                                                [indeterminate]="selection.hasValue() && !isAllSelected()">
                                            </mat-checkbox>
                                        </th>
                                        <td mat-cell *matCellDef="let row">
                                            <mat-checkbox class="header-checkBox" (click)="$event.stopPropagation()"
                                                (change)="$event ? selection.toggle(row.documentId) : null;isSomeSelected()"
                                                [checked]="selection.isSelected(row.documentId)">
                                            </mat-checkbox>
                                        </td>
                                    </ng-container>
            
                                    <!-- dynamic columns -->
                                    <ng-container *ngFor="let column of selectedFormDisplayList">
                                        <ng-container  *ngIf = "column.visible && column.type == 'original'"                    
                                        matColumnDef="{{ column.name }}"
                                        >
                                        <th
                                            id="{{ column.name }}"
                                            mat-header-cell
                                            *matHeaderCellDef
                                            mat-sort-header
                                        >
                                            {{ column.name  }}
                                        </th>
                                        <td mat-cell *matCellDef="let element" (click)="getDocDetails($event, element)" >
                                            {{ element[column.value] }}
                                        </td>
                                        </ng-container>
                                        <ng-container  *ngIf = "column.visible && column.type == 'properties' && column.data_type == 'object'"                    
                                        matColumnDef="{{ column.name }}"
                                        >
                                        <th
                                            id="{{ column.name }}"
                                            mat-header-cell
                                            *matHeaderCellDef
                                            mat-sort-header
                                        >
                                            {{ column.name  }}
                                        </th>
                                        <td mat-cell *matCellDef="let element" (click)="getDocDetails($event, element)" >
                                            {{ element.metadata.properties[column.value] | json}}
                                        </td>
                                        </ng-container>
                                        <ng-container  *ngIf = "column.visible && column.type == 'properties' && column.data_type != 'object'"                    
                                        matColumnDef="{{ column.name }}"
                                        >
                                        <th
                                            id="{{ column.name }}"
                                            mat-header-cell
                                            *matHeaderCellDef
                                            mat-sort-header
                                        >
                                            {{ column.name  }}
                                        </th>
                                        <td mat-cell *matCellDef="let element" (click)="getDocDetails($event, element)" >
                                            {{ element.metadata.properties[column.value] }}
                                        </td>
                                        </ng-container>
                                        <ng-container  *ngIf = "column.visible && column.type == 'system'"                    
                                        matColumnDef="{{ column.name }}"
                                        >
                                        <th
                                            id="{{ column.name }}"
                                            mat-header-cell
                                            *matHeaderCellDef
                                            mat-sort-header
                                        >
                                            {{ column.name  }}
                                        </th>
                                        <td mat-cell *matCellDef="let element" (click)="getDocDetails($event, element)" >
                                            {{ element.metadata.system[column.value] }}
                                        </td>
                                        </ng-container>
                                    </ng-container>
                                    <ng-container matColumnDef="actionButton">
                                        <th id="actionButton" mat-header-cell *matHeaderCellDef mat-sort-header></th>
                                        <td mat-cell *matCellDef="let element">
                                            <button mat-button [matMenuTriggerFor]="menu" (click)="subscribe(element)"
                                                [disabled]="!element.active">
                                                <mat-icon>list</mat-icon>
                                            </button>
                                            <mat-menu #menu="matMenu">
                                                <button mat-menu-item (click)="openUpdateMetaData()" [disabled]="isDocLocked">Update
                                                    Metadata</button>
                                                <button mat-menu-item (click)="openUploadDocument()" [disabled]="isDocLocked">Upload
                                                    Version</button>
                                                <button *ngIf="enableImageTrust" mat-menu-item (click)="annotateDocument()"
                                                    [disabled]="isDocLocked">Annotate
                                                    Document</button>
                                                <button mat-menu-item (click)="lockUnlockDocument(activeDocumentDetails.locked)">
                                                    <div *ngIf=isDocLocked>Unlock Document</div>
                                                    <div *ngIf=!isDocLocked>Lock Document</div>
                                                </button>
                                            </mat-menu>
                                        </td>
                                    </ng-container>
            
                                    <tr mat-header-row *matHeaderRowDef="searchResultsCols"></tr>
                                    <tr mat-row *matRowDef="let row; columns: searchResultsCols;"
                                     class="element-row"
                                    [class.selected-row]="selectedRow === row"
                                    (click)="selectedRow = selectedRow === row ? null : row">
                                    </tr>
            
                                </table>
                            </div>
                        </div>
                        <div *ngIf="isEmpty && !backSlash">
                            <div class="alert alert-light text-center">
                                {{message}}
                            </div>
                        </div>
                        <div *ngIf="backSlash && !isEmpty">
                            <div class="alert alert-light text-center">
                                {{message}}
                            </div>
                        </div>
                    </div>
                    <div class="col" *ngIf="searchExecuted && selectedDoc && hideDocList">
                        <app-display-search-doc [selectedDocument]="selectedDoc.documentId"
                            [docVersionNumber]="selectedDoc.VersionNumber" [searchResultsList]="searchResultsList" [searchText]="submittedSearchText"
                            (hideDocList)="onHideDocList($event)"></app-display-search-doc>
                    </div>
                    <div class="col-4" *ngIf="openUpload">
                        <app-dialog-upload [documentDetails]="activeDocumentDetails" (close)="closeTabs($event)"
                            (openUpload)="backFromUpload($event)">
                        </app-dialog-upload>
                    </div>
                    <div class="col-4" *ngIf="openMetaData">
                        <app-dialog-update [document]="activeDocumentDetails" (close)="closeTabs($event)"
                            (openMetaData)="backFromMetaData($event)">
                        </app-dialog-update>
                    </div>
                </div>
            </div>
        </mat-drawer-content>
    </mat-drawer-container>

</div>
<!-- Full Text Search Ends Here -->


<!--GenAI Code Starts here-->
<div *ngIf="enableGenAI" class="container-fluid">
    <div class="text-center" *ngIf="notificationMessage">
        {{notificationMessage}}
    </div>
    <div class="text-center p-3" *ngIf="!hideDocList">
        <div class="d-flex col-9 mx-auto">
            <form class="query-input row w-100">
                <input type="text" class="form-control query-input col no-border-right"
                    placeholder="Ask me anything from the repository" [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="searchText">

                <mat-select title="Select categories to search in..." class="form-control no-border" [ngClass]="{'col-2': queryEngine=='chat', 'col-3': queryEngine!='chat'}"
                    [(ngModel)]="searchCategories" [ngModelOptions]="{standalone: true}" multiple
                    (selectionChange)="onCategoriesChange()">
                    <mat-option>
                        <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'"
                            [noEntriesFoundLabel]="'Not found'" name="search" [ngModelOptions]="{standalone: true}">
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let category of accessibleCategories |stringFilter:searchCtrl:'label'"
                        [value]="category.id">{{category.label}}</mat-option>
                </mat-select>

                <mat-select *ngIf="queryEngine=='chat'" title="Select the model" class="form-control col-2 no-border"
                    [(ngModel)]="selectedModel" [ngModelOptions]="{standalone: true}">
                    <mat-option *ngFor="let model of llmModels"
                        [value]="model.value">{{model.label}}</mat-option>
                </mat-select>

                <mat-button-toggle-group [value]="queryEngine" title="Type of prompt. Selected: {{queryEngine}}"
                    (change)="onEngineChange($event)">
                    <mat-button-toggle class="toggle-label-content"
                        style="line-height: 0px !important; text-align:center;" value="chat">Chat</mat-button-toggle>
                    <mat-button-toggle class="toggle-label-content"
                        style="line-height: 0px !important; text-align:center;"
                        value="search">Search</mat-button-toggle>
                </mat-button-toggle-group>
                <div class="btn-group col-1" style="height: calc(1.5em + 0.75rem)">
                    <button type="submit" (click)="executeQueryHandler()"
                        class="btn btn-outline-secondary btn-md"><mat-icon>send</mat-icon></button>
                    <button title="Clear all" (click)="clearSearchResults()"
                        class="btn btn-outline-secondary btn-md"><mat-icon>clear_all</mat-icon></button>
                </div>
            </form>
        </div>
        <div *ngIf="showLoading" class="w-30 d-flex mt-1" style="margin-left:30%" #generatingMessage>
            <div>{{genAIGenerationMessage}}</div>
            <div class="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    </div>
    <div *ngIf="queryHistory.length>0 && !hideDocList"
        style="width: 85%;margin-left: auto !important;margin-right: auto !important;" for="qna-history">

        <div style="font-size: small; margin-top: 15px;" class="card" *ngFor="let query of queryHistory">
            <div class="card-header">
                <div for="query">
                    <strong>{{query.query}}</strong>
                </div>
            </div>
            <div class="card-body">
                <div style="white-space: pre-wrap; text-align:left; margin-top: 15px;" for="answer"
                    title="{{query.confidence!=null?(query.confidence*100):'NA'}}">
                    {{query.response.trim()}}
                </div>
            </div>
            <div class="card-footer">
                <div *ngIf="query.context.length>0" class="row m-2">
                    <div class="col-1"><strong>Context: </strong></div>
                    <div class="col-2" *ngFor="let source of query.context">
                        <a style="font-size: small;"
                            (click)="getDocDetails($event, source)">{{source.documentName.split('/').at(-1)}}</a><br>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="intelligentSearchResults">
        <div *ngIf="intelligentSearchResults.length>0 && !hideDocList" for="smart-search">
            <div style="font-size: small;width: 85%;margin-left: auto !important;margin-right: auto !important; margin-top: 5px;"
                class="card" *ngFor="let searchResult of intelligentSearchResults">
                <div class="card-body">
                    <a
                        (click)="getDocDetails($event, searchResult)">{{searchResult.documentName.split('/').at(-1)}}</a><br>
                    <div class="pt-2 pb-2"><strong>Confidence:</strong> {{searchResult.confidence}}</div>
                    {{searchResult.text.substr(0, 300)}}...
                </div>
            </div>
        </div>
        <div *ngIf="intelligentSearchResults.length<1 && !hideDocList" class="text-center">
            No documents that match the entered text.
        </div>
    </div>

    <div class="col" *ngIf="selectedDoc && hideDocList">
        <app-display-search-doc [selectedDocument]="selectedDoc.documentId"
            [docVersionNumber]="selectedDoc.VersionNumber" [searchResultsList]="searchResultsList"
            (hideDocList)="onHideDocList($event)"></app-display-search-doc>
    </div>
</div>